<template>
  <div class="yh-page">
    <el-card>
      <el-row slot="header" type="flex" justify="start" align="middle" class="p-3" :gutter="10">
        <el-col :span="24">
          <el-input placeholder="输入报备信息进行搜索..." v-model.trim="query.search"
                    @keyup.enter.native="handleSearch">
            <el-button slot="append" icon="el-icon-search" :loading="searching" @click="handleSearch">搜索</el-button>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-button v-if="$perm(['registration.import_registration'])" type="primary" size="small"
                     icon="el-icon-upload2" @click="handleRegistrationImport">导入
          </el-button>
        </el-col>
      </el-row>
      <!-- 业务table -->
      <el-table :key="0" :data="list" stripe v-loading="loading" :element-loading-text="loadingText"
                fit highlight-current-row class="w-100">
        <!-- 船舶名称 -->
        <el-table-column align="left" label="船舶名称">
          <template slot-scope="scope">
            <span class="text-link">{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <!-- 被保险人 -->
        <el-table-column align="left" label="被保险人">
          <template slot-scope="scope">
            <span>{{scope.row.insurant}}</span>
          </template>
        </el-table-column>
        <!-- 险种 -->
        <el-table-column align="left" label="险种">
          <template slot-scope="scope">
            <span>{{ scope.row.insurance_type }}</span>
          </template>
        </el-table-column>
        <!-- 推荐人（部门） -->
        <el-table-column align="left" label="推荐人（部门）" width="120px">
          <template slot-scope="scope">
            <span>{{ scope.row.referee }}</span>
          </template>
        </el-table-column>
        <!-- 业务区域 -->
        <el-table-column align="left" label="业务部门">
          <template slot-scope="scope">
            <span>{{ scope.row.business_area }}</span>
          </template>
        </el-table-column>
        <!-- 实际控制人 -->
        <el-table-column align="left" label="实际控制人">
          <template slot-scope="scope">
            <span>{{ scope.row.actual_controller }}</span>
          </template>
        </el-table-column>
        <!-- 联系人 -->
        <el-table-column align="left" label="联系人">
          <template slot-scope="scope">
            <span>{{ scope.row.contacts }}</span>
          </template>
        </el-table-column>
        <!-- 联系电话 -->
        <el-table-column align="left" label="联系电话">
          <template slot-scope="scope">
            <span v-if="$perm(['registration.view_contact_info'])">{{ scope.row.contact_phone }}</span>
            <span v-else>***********</span>
          </template>
        </el-table-column>
        <!-- 起保日期 -->
        <el-table-column align="left" label="起保日期">
          <template slot-scope="scope">
            <span>{{ scope.row.begin_date }}</span>
          </template>
        </el-table-column>
        <!-- 备注 -->
        <el-table-column align="left" label="备注">
          <template slot-scope="scope">
            <span>{{ scope.row.remark }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <pagination ref="pagination" :size.sync="query.limit" :offset.sync="query.offset" :total="total" @updateList="getList"></pagination>
    <registration-dialog ref="registration"></registration-dialog>
  </div>
</template>

<script>
  import {fetchList} from '@/api/registration'
  import RegistrationDialog from './registration-dialog'
  import Pagination from '@/components/Pagination'

  export default {
    name: "registration-list",
    components: {
      RegistrationDialog,
      Pagination
    },
    data() {
      return {
        searching: false,
        loading: false,
        loadingText: '正在加载数据，请稍等...',
        query: {
          search: '',
          offset: 0,
          limit: 20
        },
        total: 0,
        list: []
      }
    },
    methods: {
      handleSearch() {
        // this.getList()
        this.$refs.pagination.backNumOne()
      },
      getList() {
        this.loading = true
        fetchList(this.query)
          .then(res => {
            this.list = res.results
            this.total = res.count
            this.loading = false
          })
          .catch(error => {
            this.loading = false
            this.$error_message(error)
          })
      },
      handleRegistrationImport() {
        this.$refs.registration.handleRegistrationImport()
      }
    },
    created() {
      if (this.$perm(["registration.list_registration"])) {
        this.getList()
      } else {
        this.$router.push('/401')
      }
    }
  }
</script>
